<template lang="html">

    <div class="evento-barometro column-start">
        <h3>{{doc.category.name}}</h3>
        <h2>{{doc.name}}</h2>
        <p>Promoción {{doc.year}} - {{doc.year+1}}</p>
        <div class="contenedor-botones row-start" v-if="!!doc.hasFile">
            <a @click="requestDoc(doc)" class="btn -fill">Descargar</a>
        </div>
    </div>

</template>

<script lang="js">

    import { mapActions } from 'vuex';

    export default {
        name: 'fichero',
        props: ['doc'],
        methods: {
            ...mapActions(['requestBarometro','requestDoc']),
        },
        filters: {
            fecha(value) {
                let date = new Date(value);
                return `${date.getDate()}/${date.getMonth()}/${date.getFullYear()}`;
            }
        }
    }

</script>


// WEBPACK FOOTER //
// src/components/parts/fichero.vue